import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import Store from '@/store';
import authApi from '@/apis/auth-api';

Vue.use(VueRouter);

const Signin = () => import(/* webpackChunkName: "signIn" */ '../views/signin');
const Dashboard = () => import(/* webpackChunkName: "Dashboard" */ '../views/dashboard');
const Album = () => import(/* webpackChunkName: "Album" */ '../views/album');
const Category = () => import(/* webpackChunkName: "Album" */ '../views/Category');
const Gallery = () => import(/* webpackChunkName: "Album" */ '../views/gallery');
const Favourites = () => import(/* webpackChunkName: "Album" */ '../views/favourites');
const Overlay = () => import(/* webpackChunkName: "Album" */ '../components/overlay');

const routes = [
  {
    path: '/',
    component: Signin,
    name: 'home',
    meta: { auth: false, layout: 'simple' }
  },
  {
    path: '/signin',
    component: Signin,
    name: 'signin',
    meta: { auth: false, layout: 'simple' }
  },
  {
    path: '/dashboard',
    component: Dashboard,
    name: 'dashboard',
    meta: { auth: true, layout: 'default' }
  },
  {
    path: '/album',
    name: 'album',
    component: Album,
    meta: { auth: true, layout: 'default' }
  },
  {
    path: '/category/:id',
    name: 'category',
    props: true,
    component: Category,
    meta: { auth: true, layout: 'default' }
  },
  {
    path: '/gallery/:id',
    name: 'gallery',
    props: true,
    component: Gallery,
    meta: { auth: true, layout: 'default' }
  },
  {
    path: '/favourites',
    name: 'favourites',
    props: true,
    component: Favourites,
    meta: { auth: true, layout: 'default' }
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

router.mode = 'html5';
router.beforeEach((to, from, next) => {
  Store.commit('overlay_content', '');
  if (to.meta.auth) {
    // get token from storage
    const token = Store.getters.get_token;
    if (token === null || token === 'undefined') {
      // refresh token
      // returns new token if token from storage is valid
      Store.dispatch('refresh').then((response) => {
        next();
      }).catch(() => {
        next({ path: 'signin' });
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js